import { AREA_PAGES } from './areaPages'
import { NAV_DESTINATIONS, AI_ASSETS_ITEM } from './tenants'

/**
 * Where a finding's back button goes when the page did not say where it was opened from: a link
 * someone was sent, the header search, a reload. The full list, which is the one page that holds
 * every finding.
 */
export const BACK_BY_DEFAULT = '/recommendations'

/**
 * Where "back" goes from a finding: the page it was opened from, as the opener recorded it in the
 * navigation state, or the full list. Only an in-app path is taken; anything else in the state is
 * not something this app put there.
 */
export function backTarget(from: unknown): string {
  return typeof from === 'string' && from.startsWith('/') && !from.startsWith('//')
    ? from
    : BACK_BY_DEFAULT
}

/**
 * What the back button says, from where it goes: "Back to dashboard", "Back to recommendations",
 * "Back to Email".
 *
 * It said "Back to findings" wherever it went, and from the dashboard that was a promise of a list
 * kept by landing on a page of panels. The label is taken from the destination itself, so the words
 * and the place cannot disagree: an area keeps its name as written (it is a proper name on every
 * page), any other page from the navigation is in lower case, and a page this app does not name is
 * a plain "Back" rather than a guess.
 */
export function backLabel(target: string): string {
  const path = target.split(/[?#]/)[0] ?? ''

  const area = Object.entries(AREA_PAGES).find(([, page]) => page === path)?.[0]
  if (area) return `Back to ${area}`

  if (path === AI_ASSETS_ITEM.path) return 'Back to AI assets'

  const page = NAV_DESTINATIONS.find((item) => item.path === path)?.label
  if (page) return `Back to ${page.toLowerCase()}`

  return 'Back'
}
